import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Flex, Link } from '@iheartjane/reefer';

import { normalizeUrl } from '@jane/shared/util';

interface AgreementLinksProps {
  agreementLabel?: string;
  external_link: string | null;
  external_links: Array<{ label: string; url: string }>;
  id?: string;
}

export const AgreementLinks = ({
  id,
  agreementLabel,
  external_link,
  external_links,
}: AgreementLinksProps) => {
  const multipleLinks = useFlag(FLAGS.c1MultipleCheckoutAgreements);

  if (multipleLinks && external_links.length > 0) {
    return (
      <Flex
        id={id}
        as="ul"
        flexDirection="column"
        gap={8}
        pt={12}
        pl={32}
        aria-label={
          agreementLabel
            ? `Agreement links for: ${agreementLabel}`
            : 'Agreement links'
        }
      >
        {external_links.map((link, index) => (
          <li key={index}>
            <Link href={normalizeUrl(link.url)}>
              {link.label || 'View Agreement'}
            </Link>
          </li>
        ))}
      </Flex>
    );
  }

  if (external_link) {
    return (
      <Link id={id} href={normalizeUrl(external_link)} mt={12} ml={32}>
        View Agreement
      </Link>
    );
  }

  return null;
};
